import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetHelpdeskCSAll } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (spvid) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiUrl2 + 'config-cs-list';
    var paramBody = {
        "query":{
            "search":"",
            "page":1,
            "page-size":1000,
            "order-by":1,
            "order":"ASC",
            "spv-id": spvid
        }
    };
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        data = data.get('data');
    }

    dispatch({ type: GetHelpdeskCSAll, data: fromJS(data) });
};